import { Stack, ButtonGroup } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import MultiSelectField from "components/FormElements/Fields/SelectFields/MultiSelectField";
import { DEFAULT_FIELD_GAP } from "definitions/constants/styling";
import { useUpdateUserRoles } from "features/User/hooks";
import { User } from "features/User/models";
import ProceedCancelButtons from "../Button/ProceedCancelButtons";

const updateRolesForm = yup.object({
  roles: yup.array().label("Roles").required(),
});

const ROLES_FIELD = {
  type: "multiSelect",
  label: "Roles",
  name: "roles",
  options: [
    { value: "onboarder", label: "Onboarder" },
    { value: "manager", label: "Manager" },
    { value: "people_team", label: "People Team" },
    { value: "basic", label: "Basic Employee" },
    { value: "company_admin", label: "Company Admin" },
    { value: "it_admin", label: "IT Admin" },
  ],
};

interface UpdateRolesFormProps {
  user: User;
  onClose?: () => void;
  onSuccess?: () => void;
}

export default function UpdateRolesForm({ user, onClose = () => {}, onSuccess = () => {} }: UpdateRolesFormProps) {
  const {
    formState: { errors, isDirty },
    handleSubmit,
    control,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(updateRolesForm),
    values: { roles: user?.permission },
  });

  const { mutate: updateUserRoles, isPending } = useUpdateUserRoles(user, () => {
    onSuccess?.();
    onClose?.();
  });

  return (
    <Stack gap={DEFAULT_FIELD_GAP}>
      <MultiSelectField
        menuPlacement="top"
        errors={errors}
        control={control}
        {...ROLES_FIELD}
        required
      />
      <ButtonGroup display="flex" justifyContent="flex-end">
        <ProceedCancelButtons
          handleSubmit={handleSubmit(updateUserRoles)}
          onClose={onClose}
          proceedText="Update Roles"
          proceedDisabled={!isDirty}
          isLoading={isPending}
        />
      </ButtonGroup>
    </Stack>
  );
}
